import React, { useContext, useState } from "react";
import { exportToZIP } from "./exportUtils";
import AuthContext from "../../context/auth/authContext";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import axios from "axios";
import { toast } from "react-toastify";

const ExportZipButton = ({ getCurrentFilters, 
  appUrl: reactAppUrl,
  onExportStart,
  onExportComplete
}) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext || {};
  const adminLeloContext = useContext(AdminLeloContext);
  const {
    getLeloEntriesOptimizezip,
    searchText,
    startDate,
    endDate
  } = adminLeloContext;
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
 // Call parent's onExportStart callback to show the message
      if (onExportStart) {
        onExportStart();
        toast.success("Export to ZIP initiated successfully");
      }
      const filters = getCurrentFilters();
      // console.log("getCurrentFilters:", filters);
      const exportData = await getLeloEntriesOptimizezip({
        status: filters.status,
        permaLink: filters.permaLink,
        searchText,
        startDate,
        endDate
      });

      const dataToExportZip = Array.isArray(exportData)
        ? exportData.map((item) => ({
          ...item,
          PermaLink: `${reactAppUrl}/forms/${item.permaLink}/${item._uuid}`,
        }))
        : [];

      if (dataToExportZip.length === 0) {
        toast.error("No data available to export with the current filters.");
        return;
      }

      exportToZIP(dataToExportZip, "LeloForms_data");

      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }

      await axios.post(`${appUrl}/api/dataexport`, {
        user_name: user?.name ?? "Unknown",
        azure_id: user?.azureID ?? "Unknown",
        fileName: "LeloForms_data",
        recordCount: dataToExportZip.length,
        screen: "Secondary Enrollments Admin Screen",
        exportType: "zip",
        exportStatus: "success",
      });
    } catch (error) {
      console.error("Error during export:", error);
      toast.error("An error occurred while exporting the data.");
    } finally {
      setIsExporting(false);
      // Call parent's onExportComplete callback to hide the message
      if (onExportComplete) {
        onExportComplete();
      }
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className="btn btn-llac-dark-green btn-export-zip">
      {isExporting ? "Exporting..." : "Export to ZIP"}
    </button>
  );
};

export default ExportZipButton;
